import { useSelector } from 'react-redux'
import { Element } from '../../../../../common/html/element'
import { TextEllipsisStaticLine } from '../../../../../common/textEllipsis/TextEllipsisStaticLine'
import { COMPONENTS } from '../../../../../routers/constants'
import { LinkComponent } from '../../../../common/html/LinkComponent'
import { TYPE_REPORTS, TYPE_REPORTS_SELECT } from '../../constant'
import { selectDataTableReports } from '../../store/slice'

export const CustomTdName = ({ value, rowId }) => {
  const dataRow = useSelector(selectDataTableReports(rowId))

  return (
    <LinkComponent
      href={
        dataRow?.reportTypeId === TYPE_REPORTS_SELECT[TYPE_REPORTS.BUSINESS].id
          ? `${COMPONENTS.companyAnalysis.components.summary.route}?organizationId=${dataRow?.organizationId}&isOrderBl=true`
          : dataRow?.sourceUrl
      }
    >
      <Element
        style={{
          color: '#2C73E8',
        }}
      >
        <TextEllipsisStaticLine text={value} lineClamp={1} isI18n={false} />
      </Element>
    </LinkComponent>
  )
}
